/**
 * This pointless re-export of window.performance
 * is to allow us to jest test code which uses the performance
 * object - as unfortunately Jest removes any direct mocks of
 * performance that we try to set: https://github.com/jestjs/jest/issues/12055
 */
export const performance = window.performance;
